<template>
    <!-- <v-layout class="footer"> -->
    <v-footer
    height="auto"
    position="absolute"
    >
    <v-layout id="footerBody" align-center justify-space-between row fill-height px-3 py-2>
      <v-flex xs12>
        <div class="orange-bar">
          <h3>
            Please submit your survey response by
            <br/><strong>August 6<sup>th</sup> 2025</strong>
          </h3>
        </div>
      </v-flex>
      <v-flex row sm12 mb-sm-3 md5 mb-md-0 lg4 ml-0 mr-0 justify-start class="footerItem">
          <div class="mr-2">
              <img class="footer-icon-left" width="40px" src="../assets/icon-techsupport.png" alt="computer icon">
          </div>
            <div class="footer-text-left">
              <h4>Technical Support</h4>
              <p><a href="mailto:NCSES-FedFundsSurvey@nsf.gov">NCSES-FedFundsSurvey@nsf.gov</a></p>
              <p>(703) 312-5379<br/>Help Desk Hours:  9 am – 5 pm,  Mon-Fri ET</p>
            </div>
      </v-flex>
      <v-flex row sm12 mb-sm-3 md5 mb-md-0 lg5 ml-0 mr-0 justify-start class="footerItem">
          <div class="pl-lg-3 mr-2">
            <img  class="footer-icon-left" width="40px" src="../assets/icon-questions.png" alt="pencil icon">
          </div>
          <div class="footer-text-middle">
            <h4>General Survey Questions</h4>
            <p>Christopher Pece, National Center for Science and Engineering Statistics, NSF</p>
            <p><a href="mailto:cpece@nsf.gov">cpece@nsf.gov</a><br/>(703) 292-7788</p>
          </div>
      </v-flex>
      <v-spacer>
      </v-spacer>
      <v-flex sm12 md2 lg2 class="footer-text-right">
          <div>&copy; 2020 National Science Foundation
          </div>
      </v-flex>

    </v-layout>
  </v-footer>
</template>

<script>
import Vue from "vue";
export default {
  name: 'Footer'
};
</script>

<style scoped>

#footerBody {
  padding-left: 16px !important; /* both needed to deal w/differing padding on Survey vs Landing pages */
  padding-right: 16px !important;
}

.footerItem {
  flex-wrap: nowrap;
  text-align: left;
}

.footerItem:first-child {
    border-right: 1px solid #9dc4d1;
}

.footerLeft {
  padding: 10px;
}

.footerLeft > div {
  margin-right: 10px;
}

.v-footer {
  border-top: 1px solid lightgray !important;
  border-bottom: 1px solid lightgray !important;
  background-color: #f0f0f0 !important;
  font-size: 9pt;
}

.v-footer h4 {
  font-size: 10pt;
  margin-bottom: 4px;
  font-weight: bold;
}
.v-footer p {
  margin: 0;
}

.v-footer a {
    color: #125289 !important;  /* 508 AAA > 7 */
}

.footer-icon-left {
  margin-right: 10px;
}
.footer-icon-middle {
  margin-top: 0px;
}
.footer-text-left {
  padding-right: 15px;
}
.footer-text-right {
  font-size: 9pt;
  display: flex;
  align-items: flex-end;
  align-self: flex-end; /* hack needed for Survey page */
  text-align: right;
}

@media (max-width: 960px) {

  .footerItem:first-child {
      border-right: none;  /* hide border when footer goes to two rows */
  }

}

</style>
